export function wavefrontExpansion<T>(
	startingNodes:Iterable<T>,
	connections:(node:T)=>Iterable<T>,
	iterate:(a:T,b:T)=>void,
	step?:(nodes:Set<T>)=>void,
){

	let working=new Set<T>(startingNodes);
	if(working.size===0)
		return;
	let next=new Set<T>();
	let closed=new Set<T>(working);
	do{
		step?.(working);
		for(const a of working){
			for(const b of connections(a)){
				if(closed.has(b))
					continue;
				iterate(a,b);
				next.add(b);
			}
		}
		for(const node of next)
			closed.add(node);
		[working,next]=[next,working];
		next.clear();
	}while(working.size>0);
}